<template src="../templates/normal_fcont_143.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import CreatorProfileGoTomochika from '../components/CreatorProfileGoTomochika'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    InfoMachineTranslation,CreatorProfileGoTomochika,AppDownloadiPrint,
    AppDownloadSmartPanel
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['143-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['143-2']}
      ]
    };
  }
  
};
</script>
<style >
</style>

